var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bj-col bj-col-24" },
    [
      _c("div", { staticClass: "main-title" }, [
        _vm._v("Cargo Solutions Group Pty Ltd"),
      ]),
      _c("div", { staticClass: "middle-title" }, [
        _vm._v("62 Goodall Close, Dandenong South VlC 3175"),
      ]),
      _c(
        "el-descriptions",
        {
          attrs: {
            column: "2",
            colon: false,
            labelClassName: "label-class-name",
            contentClassName: "content-class-name",
          },
        },
        [
          _c(
            "el-descriptions-item",
            {
              attrs: {
                label: this.$t("InternalSalesOrderDetails.CustomerName"),
              },
            },
            [_vm._v(_vm._s(_vm.rowData.customerName))]
          ),
          _c(
            "el-descriptions-item",
            {
              attrs: {
                label: this.$t("InternalSalesOrderDetails.PaymentStatus"),
                contentClassName: [_vm.targetGroupClass, "content-class-name"],
                labelStyle: { marginLeft: "30%" },
              },
            },
            [_vm._v(_vm._s(_vm.paymentStatusShow))]
          ),
          _c(
            "el-descriptions-item",
            {
              attrs: { label: this.$t("InternalSalesOrderDetails.PaymentId") },
            },
            [_vm._v(_vm._s(_vm.rowData.paymentID))]
          ),
          _c(
            "el-descriptions-item",
            {
              attrs: {
                label: this.$t("InternalSalesOrderDetails.InvoiceNo"),
                labelStyle: { marginLeft: "30%" },
              },
            },
            [_vm._v(_vm._s(_vm.rowData.invoiceNo))]
          ),
          _c(
            "el-descriptions-item",
            {
              attrs: { label: this.$t("InternalSalesOrderDetails.OrderDate") },
            },
            [_vm._v(_vm._s(_vm.rowData.orderDate))]
          ),
          _c(
            "el-descriptions-item",
            {
              attrs: {
                label: this.$t("InternalSalesOrderDetails.InvoiceWeek"),
                labelStyle: { marginLeft: "30%" },
              },
            },
            [_vm._v(_vm._s(_vm.rowData.invoiceWeek))]
          ),
        ],
        1
      ),
      _c("table", { staticClass: "table-custom" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [
              _vm._v(
                _vm._s(this.$t("InternalSalesOrderDetails.PaymentTableNO"))
              ),
            ]),
            _c("th", [
              _vm._v(
                _vm._s(this.$t("InternalSalesOrderDetails.PaymentTableItem"))
              ),
            ]),
            _c("th", [
              _vm._v(
                _vm._s(this.$t("InternalSalesOrderDetails.PaymentTableQty"))
              ),
            ]),
            _c("th", [
              _vm._v(
                _vm._s(this.$t("InternalSalesOrderDetails.PaymentTablePrice"))
              ),
            ]),
            _c("th", [
              _vm._v(
                _vm._s(this.$t("InternalSalesOrderDetails.PaymentTableTotal"))
              ),
            ]),
          ]),
        ]),
        _c(
          "tbody",
          [
            _vm._l(_vm.rowData.transactionItems, function (item, index) {
              return _c("tr", { key: item.no }, [
                _c("td", [_vm._v(_vm._s(index + 1))]),
                _c("td", [_vm._v(_vm._s(item.itemName))]),
                _c("td", [_vm._v(_vm._s(item.qty))]),
                _c("td", [_vm._v(_vm._s(item.unitPrice))]),
                _c("td", [_vm._v(_vm._s(item.total))]),
              ])
            }),
            _c("tr", [
              _c("td", { attrs: { colspan: "3" } }),
              _c("td", [
                _vm._v(
                  _vm._s(
                    this.$t("InternalSalesOrderDetails.PaymentTableSubTotal")
                  )
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.rowData.subTotal))]),
            ]),
            _c("tr", [
              _c("td", { attrs: { colspan: "3" } }),
              _c("td", [
                _vm._v(
                  _vm._s(this.$t("InternalSalesOrderDetails.PaymentTableGST"))
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.rowData.gst))]),
            ]),
            _c("tr", [
              _c("td", { attrs: { colspan: "3" } }),
              _c("td", [
                _vm._v(
                  _vm._s(
                    this.$t("InternalSalesOrderDetails.PaymentTableSubTotalGST")
                  )
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.rowData.total))]),
            ]),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }